export class Usuario {

 public id:number;
 public email:string;
 public nombre:string;
 public apellidos:string;
 public clave:string;
 public tipo:string;
 public codigoConsorcio:string;
 public usuario:string;


}


// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/usuario.ts